import type { WebsiteHeaderPhotoSchema_Monogram } from '@shared/types/WebsiteHeaderSettings.types';

export const MONOGRAM_DEFAULT: WebsiteHeaderPhotoSchema_Monogram = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/monogram-v1_1_1.json',
  presentationLayout: 'monogram',
  jsonContainerId: null,
};
